import error from 'aurora-utils/error';
import get from 'lodash/get';
import * as types from './constants';

const defaultState = {
  loading: false,
  error,
  contacts: [],
};

export default function primaryContactReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.FETCH_OFFPLAN_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_OFFPLAN_BUYER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_OFFPLAN_BUYER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_PRIMARY_CONTACT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_PRIMARY_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        contacts: get(action.payload, 'contacts', []),
      };
    case types.FETCH_PRIMARY_CONTACT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.ADD_PRIMARY_CONTACT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_PRIMARY_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.ADD_PRIMARY_CONTACT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.REMOVE_PRIMARY_CONTACT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.REMOVE_PRIMARY_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.REMOVE_PRIMARY_CONTACT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
